<figure class="preview-container">
  <ul class="layers">
    @for (door of doors; track door.id) {
      <li
        class="sublayer"
        role="button"
        tabindex="0"
        (click)="selectDoor(door.id)"
        (keydown.enter)="selectDoor(door.id)"
        (keydown.space)="selectDoor(door.id)"
        [ngClass]="{
          active: door.id === selectedDoorId && finishesStep === SubStep.Doors,
          profile: finishesStep !== SubStep.Colors,
          decoration: finishesStep === SubStep.Colors,
          front: isInFront(door.id),
          rear: !isInFront(door.id),
        }"
        [id]="'door' + door.id"
        [ngStyle]="{
          'margin-left': isOffset(door.id) ? calculateOffset(door.id) : null,
        }">

        <!-- Image calque — en flux normal pour fixer la hauteur du sublayer -->
        @if (door.layer) {
          <img [src]="baseImgURL + door.layer.layer" alt="" />
        }

        <!-- Sections colorées — visibles dans tous les sous-pas, cliquables uniquement en sous-pas Décors -->
        @if (door.sections?.length > 0) {
          <div class="sections-container">
            @for (section of door.sections; track section.index) {
              <div
                class="door-section"
                [class.active]="finishesStep === SubStep.Colors && isActiveSection(door.id, section.index)"
                [class.fixed]="section.isFixed"
                [style.height]="section.heightPercentage + '%'"
                [style.background-image]="getSectionBackground(section)"
                (click)="finishesStep === SubStep.Colors && !section.isFixed ? $event.stopPropagation() : null; finishesStep === SubStep.Colors && !section.isFixed ? selectSection(door.id, section.index) : null"
                [attr.role]="finishesStep === SubStep.Colors && !section.isFixed ? 'button' : null"
                [attr.tabindex]="finishesStep === SubStep.Colors && !section.isFixed ? 0 : null">
              </div>
            }
          </div>

          <!-- Profilé superposé par-dessus les sections -->
          @if (door.layer) {
            <img [src]="baseImgURL + door.layer.layer" class="layer-frame" alt="" />
          }

          <!-- Icône d'édition par section configurable non active — sous-pas Décors uniquement -->
          @if (finishesStep === SubStep.Colors) {
            @for (section of door.sections; track section.index) {
              @if (!section.isFixed && !isActiveSection(door.id, section.index)) {
                <div
                  class="decoration-button"
                  [ngStyle]="{ top: getSectionMidpoint(door, section) + '%' }"
                  (click)="$event.stopPropagation(); selectSection(door.id, section.index)">
                  <img class="pencil" src="assets/img/closet-doors/pencil-solid.svg" [alt]="'generic.update' | translate" />
                </div>
              }
            }
          }
        }
      </li>
    }
  </ul>
</figure>
<div class="preview-floor"></div>
